import React, { createContext, useContext, useEffect, useState } from "react";
import { CustomSelect } from "../../components/customSelect/CustomSelect";
import { getBearer } from "../../functions/getBearer";
import axios from "axios";
import { getApiLink } from "../../functions/getApiLink";
import { Translate } from "../../components/translate/Translate";
import "./styles/main.scss"
import { useClickOutside } from "../../hooks/ClickOutside";
import { SelectDate } from "../../components/select/SelectDate";
import { MonthNumber } from "../../constants/MonthNumber";
import { AnimatePresence, motion } from "framer-motion";
import AnalyticsItem from "./components/AnalyticsItem";
import { PopupContext } from "../../App";
import ProjectsSelect from "./components/ProjectsSelect";
import { Notifications } from "../../components/notifications/Notifications";
import getAnalitycsData from "../../functions/getAnalitycsData";
import { generateColors } from "./components/getColors";
import { handleDownloadAnalyticsData } from "./components/handleDownloadAnalyticsData";
import EmployeesSelect from "./components/EmployeesSelect";
import { useTranslation } from "react-i18next";
import { findMissingNames } from "./components/checkNames";
import { handleDownloadFullAnalyticsData } from "./components/handleDownloadFullAnalyticsData";
import { GlobalAnalyticsData, useAnalyticsData } from "./components/useAnalyticsData";
import { toast } from "react-toastify";
import { IAnalyticsData, IProject, IEmployer, ITimeDetail, ICostDetail, ICategory, ICategoryReport, ICategoryReportRequest, ICategoryTimeData, ICategoryReportItem, ICategoryReportItemUser } from "./types";
import CategoriesSelect from "./components/CategoriesSelect";
import AnalyticsCategoriesItem from "./components/AnalyticsICategoriestem";

interface ICostsProps {}

export const BlockToEdit: any = createContext(null);
export const BlockToDuplicate: any = createContext(null);
export const FixedTopEdit: any = createContext(null);
export const AmountStatistic: any = createContext(null);

const projectStatisticList = [
  {
      label: <Translate>analytics_page.statistic_report.project</Translate>,
      value: "project_statistic_report"
  },
  {
      label: <Translate>analytics_page.statistic_report.employee</Translate>,
      value: "employee_statistic_report"
  },
  {
      label: <Translate>analytics_page.statistic_report.category</Translate>,
      value: "category_statistic_report"
  }
]

export const Analytics: React.FC<ICostsProps> = () => {

  const { t } = useTranslation();

  const actualMonth = String(new Date().getMonth() + 1)
  const actualYear = String(new Date().getFullYear());

  const [projectStatisticValue, setProjectStatisticValue] = useState(projectStatisticList[0])

  const setPopup: any = useContext(PopupContext);

  const { globalAnalyticsData, setGlobalAnalyticsData } = useAnalyticsData(),
  [analitycsData, setAnalyticsData] = useState<IAnalyticsData[]>(globalAnalyticsData?.list || []),
  [categoriesAnalitycsData, setCategoriesAnalyticsData] = useState<ICategoryReport>(globalAnalyticsData?.categoriesData || { categories: [] }),
  [fromYear, setFromYear] = useState(globalAnalyticsData?.date?.[0] || 2024),
  [fromChosenYear, setFromChosenYear] = useState(globalAnalyticsData?.date?.[0] || 2024),
  [fromMonth, setFromMonth] = useState(globalAnalyticsData?.date?.[1] || 1),
  [toYear, setToYear] = useState(globalAnalyticsData?.date?.[2] || new Date().getFullYear()),
  [toChosenYear, setToChosenYear] = useState(globalAnalyticsData?.date?.[2] || new Date().getFullYear()),
  [toMonth, setToMonth] = useState(globalAnalyticsData?.date?.[3] || new Date().getMonth()+1),
  [isActiveSelectTime, setIsActiveSelectTime] = useState(false),
  [selectDateList, setSelectDateList] = useState<HTMLElement[]>([]),
  {rootEl} = useClickOutside(setIsActiveSelectTime, selectDateList);

  const [isLoadingCreatingReport, setIsLoadingCreatingReport] = useState(false),
  [isLoadedCreatingReport, setIsLoadedCreatingReport] = useState(globalAnalyticsData?.list?.length ? true : false),
  [projectsList, setProjectsList] = useState<IProject[]>([]),
  [employeesList, setEmployeesList] = useState<IEmployer[]>([]),
  [chosenProjects, setChosenProjects] = useState<IProject[]>(globalAnalyticsData?.chosenProjects || []),
  [chosenEmployees, setChosenEmployees] = useState<IEmployer[]>(globalAnalyticsData?.chosenEmployees || []),
  [chosenProjectsForCategories, setChosenProjectsForCategories] = useState<IProject[]>(globalAnalyticsData?.chosenProjectsForCategories || []),
  [chosenEmployeesForCategories, setChosenEmployeesForCategories] = useState<IEmployer[]>(globalAnalyticsData?.chosenEmployeesForCategories || []),
  [chosenCategories, setChosenCategories] = useState<ICategory[]>(globalAnalyticsData?.chosenCategories || []),
  [resultType, setResultType] = useState<GlobalAnalyticsData["resultType"]>(globalAnalyticsData?.resultType || null);

  function handleEntirePeriod() {
    setFromMonth(1);
    setFromYear(2024);
    setToMonth(+actualMonth);
    setToYear(+actualYear);
  }

  function getSortedList(order: string[], objects: any[], is_project: boolean) {

    if(is_project) {
      const orderMap = order.reduce((map, item, index) => {
        const firstPart = is_project ? item.split('_')[0] : item;
        map[firstPart] = index;
        return map;
      }, {} as Record<string, number>);

      const sortedObjects = objects.sort((a, b) => {
        const aFirstPart = a.name.split('_')[0];
        const bFirstPart = b.name.split('_')[0];
        
        return orderMap[aFirstPart] - orderMap[bFirstPart];
        
      });
  
      return sortedObjects;
    } else {
      const orderMap = order.reduce((map, item, index) => {
        map[item] = index;
        return map;
      }, {} as Record<string, number>);

      const sortedObjects = objects.sort((a, b) => {
        return orderMap[a.name] - orderMap[b.name];
      });
  
      return sortedObjects;
    }
    
  }

  function createReport(withDetails?: boolean, onFinish?: (data: IAnalyticsData[]) => void, selected?: {projects?: IProject[], employer?: IEmployer[]}) {
    if(projectStatisticValue.value === "project_statistic_report") {

      getBearer("post");
        axios
          .post(getApiLink(`/api/analytics/projects/reports/`), {
            "end_month": toMonth,
            "end_year": toYear,
            "entire_period": false,
            "names": selected?.projects?.length ? selected.projects.map(item => item.name) : chosenProjects.map(item => item.name),
            "start_month": fromMonth,
            "start_year": fromYear,
            "time_details": withDetails,
            "cost_details": withDetails
          })
          .then(({ data }) => {
            const resultData = [] as IAnalyticsData[],
            projectsList = selected?.projects?.length ? selected?.projects : chosenProjects;

            const timeDetails: ITimeDetail[] = data.time_details || [], costDetails: ICostDetail[] = data.cost_details || [];
            data = data.aggregated_data

            const sortedData = getSortedList(projectsList.map(item => item.name), data, true);
            
            const names = sortedData.map((item: any) => ({name: item.name})),
            chosenNames = projectsList.map(item => `${item.name}_${item.description}`),
            missingNames = findMissingNames(names, chosenNames);
            if(missingNames.length && !withDetails) {
              setPopup({popup: "generated-projects-list-popup", data: missingNames})
            }
            
            if(sortedData.length) {
              sortedData.forEach((dataItem: any) => {
              
                const 
                colors = generateColors(Math.max(dataItem.time_statistics ? dataItem.time_statistics.length : 0, dataItem.cost_statistics ? dataItem.cost_statistics.length : 0)),
                timeData = dataItem.time_statistics ? getAnalitycsData(dataItem.time_statistics, "hours", colors) : null,
                costData = dataItem.cost_statistics ? getAnalitycsData(dataItem.cost_statistics, "uah", colors) : null;
      
                resultData.push(
                  {
                    ...dataItem,
                    time_statistics: timeData,
                    cost_statistics: costData,
                    time_details: timeDetails.filter(item => dataItem.name.split("_")[0] === item.project_name),
                    cost_details: costDetails.filter(item => dataItem.name.split("_")[0] === item.project_name),
                  }
                )
              })

              const nameOrder = new Map<string, number>(projectsList.map((item: { name: string, description: string }, index: number) => [`${item.name}_${item.description}`, index]));

              resultData.sort((a, b) => {
                return (nameOrder.get(a.name) || 0) - (nameOrder.get(b.name) || 0);
              });
      
              if(!withDetails) setAnalyticsData(resultData);

              setGlobalAnalyticsData({
                type: "project_statistic_report",
                date: [fromYear, fromMonth, toYear, toMonth],
                list: resultData,
                categoriesData: { categories: [] },
                categoriesTimeData: {
                  categories: [],
                  employees: []
                },
                chosenProjects, chosenEmployees,
                chosenProjectsForCategories, chosenEmployeesForCategories,
                chosenCategories,
                resultType: "projects"
              })

            } else {
              if(!withDetails) setAnalyticsData([]);
            }
            
            setResultType("projects");
            setIsLoadingCreatingReport(false);
            setIsLoadedCreatingReport(true);

            if(onFinish) onFinish(resultData);
            
          }).catch((error) => {
            console.log(error);
            toast.error(t("errors.500"));

            setIsLoadingCreatingReport(false);
            setIsLoadedCreatingReport(true);
          });
          
    } else if(projectStatisticValue.value === "employee_statistic_report") {

      getBearer("post");
      axios
        .post(getApiLink(`/api/analytics/employees/reports/`), {
          "end_month": toMonth,
          "end_year": toYear,
          "entire_period": false,
          "names": selected?.employer?.length ? selected.employer.map(item => `${item.first_name} ${item.last_name}`) : chosenEmployees.map(item => `${item.first_name} ${item.last_name}`),
          "start_month": fromMonth,
          "start_year": fromYear,
          "time_details": withDetails,
          "cost_details": withDetails
        })
        .then(({ data }) => {
          let resultData = [] as IAnalyticsData[];

          const timeDetails: ITimeDetail[] = data.time_details || [], costDetails: ICostDetail[] = data.cost_details || [];
          const employersList = selected?.employer?.length ? selected?.employer : chosenEmployees;
          data = data.aggregated_data;

          const sortedData = getSortedList(employersList.map(item => `${item.first_name} ${item.last_name}`), data, false);

          const names = sortedData.map((item: any) => ({name: item.name})),
          chosenNames = employersList.map(item => `${item.first_name} ${item.last_name}`),
          missingNames = findMissingNames(names, chosenNames);

          if(missingNames.length) {
            setPopup({popup: "generated-projects-list-popup", data: missingNames})
          }

          if(sortedData.length) {
            sortedData.forEach((dataItem: any) => {
              const 
              colors = generateColors(Math.max(dataItem.time_statistics ? dataItem.time_statistics.length : 0, dataItem.cost_statistics ? dataItem.cost_statistics.length : 0)),
              timeData = dataItem.time_statistics ? getAnalitycsData(dataItem.time_statistics, "hours", colors) : null,
              costData = dataItem.cost_statistics ? getAnalitycsData(dataItem.cost_statistics, "uah", colors) : null;
    
              resultData.push(
                {
                  ...dataItem,
                  time_statistics: timeData,
                  cost_statistics: costData,
                  time_details: timeDetails.filter(item => dataItem.name === item.user_name),
                  cost_details: costDetails.filter(item => dataItem.name === item.user_name),
                }
              )
            })
    
            if(!withDetails) setAnalyticsData(resultData);

            setGlobalAnalyticsData({
              type: "employee_statistic_report",
              date: [fromYear, fromMonth, toYear, toMonth],
              list: resultData,
              categoriesData: { categories: [] },
              categoriesTimeData: {
                categories: [],
                employees: []
              },
              chosenProjects, chosenEmployees,
              chosenProjectsForCategories, chosenEmployeesForCategories,
              chosenCategories,
              resultType: "employees"
            })

          } else {
            if(!withDetails) setAnalyticsData([]);
          }
          
          setResultType("employees");
          setIsLoadingCreatingReport(false);
          setIsLoadedCreatingReport(true);

          if(onFinish) onFinish(resultData);
          
        }).catch((error) => {
          console.error(error);
          toast.error(t("errors.500"));

          setIsLoadingCreatingReport(false);
          setIsLoadedCreatingReport(true);
        });

    } else if(projectStatisticValue.value === "category_statistic_report") {

      // Kept so the export can ask for the same slice of data task by task
      // without re-deriving these filters and drifting from the report.
      const categoriesRequest: ICategoryReportRequest = {
        "categories": chosenCategories.map(item => item.value),
        "end_month": toMonth,
        "end_year": toYear,
        "entire_period": false,
        "users": (chosenEmployeesForCategories && employeesList && chosenEmployeesForCategories.length === employeesList.length) ? [] : (chosenEmployeesForCategories || []).filter(item => item).map(item => item.id),
        "projects": (chosenProjectsForCategories && projectsList && chosenProjectsForCategories.length === projectsList.length) ? [] : (chosenProjectsForCategories || []).filter(item => item).map(item => item.id),
        "start_month": fromMonth,
        "start_year": fromYear
      };

      getBearer("post");
      axios
      .post(getApiLink("/api/analytics/categories/reports/"), categoriesRequest)
      .then(({ data } : { data: ICategoryReport }) => {

        let names: {name: string}[] = [], resultData = data as ICategoryReport,
        chosenNames: string[] = [...chosenEmployeesForCategories.map((item: IEmployer) => `${item.first_name} ${item.last_name}`)];

        chosenCategories.forEach(category => {
          if(!resultData.categories.find(item => item.name === category.value)) {
            resultData.categories.push({
              name: category.value as ICategoryReportItem["name"],
              users: []
            })
          }
        })

        data.categories.forEach((item: ICategoryReportItem) => {
          item.users.forEach((user: ICategoryReportItemUser) => {
            if(!names.find(element => element.name === user.name)) {
              names.push({name: user.name});
            }
          })
        });

        const missingNames = findMissingNames(names, chosenNames);
        if(missingNames.length && !withDetails) {
          setPopup({popup: "generated-projects-list-popup", data: missingNames})
        }

        missingNames.forEach(missingName => {

          chosenCategories.forEach(category => {
            if(!resultData.categories.find(item => item.name === category.value)) {
              resultData.categories.push({
                name: category.value as ICategoryReportItem["name"],
                users: []
              })
            }
          })

          resultData.categories.forEach(category => {
            if(!category.users.find(user => user.name === missingName)) {
              category.users.push({
                name: missingName,
                projects: []
              });
            }
          })

        });

        setCategoriesAnalyticsData(data);
        setResultType("categories");

        const categoriesTimeData: {name: string, value: number}[] = [];
        const employeesTimeData: {name: string, value: number}[] = [];

        const useCompanyAggregation = (data as any)?.company_aggregation === true;

        data.categories.forEach(category => {
          // Use company-level aggregated hours (company_hours) when present (authoritative from backend)
          // Fallback to summing user/project hours only when company_hours is not provided.
          const companyVal = (category as any).company_hours;
          let catValue = 0;

          if(typeof companyVal === 'number') {
            // Use backend-provided company total to match DB semantics exactly
            catValue = companyVal;
          } else {
            // Fallback: compute total from user/project breakdown
            category.users.forEach(user => {
              if(!user.projects || !user.projects.length) return;

              user.projects.forEach(project => {
                catValue += project.hours;
              })
            })
          }

          categoriesTimeData.push({name: category.name, value: catValue});

          // Build per-employee totals from categories using explicit user/project breakdowns when available.
          // We use backend-provided company_hours for category totals, but still show per-user data when provided.
          if(Array.isArray((category as any).users) && (category as any).users.length > 0) {
            category.users.forEach(user => {
              const userValue = (user.projects || []).reduce((s: number, p: any) => s + (p.hours || 0), 0);
              if(userValue === 0) return;
              const existing = employeesTimeData.find(item => item.name === user.name);
              if(existing) existing.value += userValue; else employeesTimeData.push({name: user.name, value: userValue});
            })
          }
        })

        const colors = generateColors(Math.max(categoriesTimeData.length, employeesTimeData.length));

        setGlobalAnalyticsData({
          type: "category_statistic_report",
          date: [fromYear, fromMonth, toYear, toMonth],
          list: [],
          categoriesData: { categories: [], company_aggregation: useCompanyAggregation } as any,
          categoriesTimeData: {
            categories: getAnalitycsData(categoriesTimeData, "value", colors) as ICategoryTimeData["categories"],
            employees: getAnalitycsData(employeesTimeData, "value", colors) as ICategoryTimeData["employees"]
          },
          chosenProjects, chosenEmployees,
          chosenProjectsForCategories, chosenEmployeesForCategories,
          chosenCategories,
          categoriesRequest,
          resultType: "categories"
        });
        setAnalyticsData([]);

        setIsLoadingCreatingReport(false);
        setIsLoadedCreatingReport(true);

        //if(onFinish) onFinish(data);
        
      }).catch((error: any) => {
        console.error(error);
        toast.error(t("errors.500"));

        // keep state flags in catch minimal to avoid nested-scope parse issues
        setIsLoadingCreatingReport(false);
        setIsLoadedCreatingReport(true);
      });
    }
  }

  function handleCreateReport() {
    setIsLoadingCreatingReport(true);
    setIsLoadedCreatingReport(false);

    createReport();
  }

  useEffect(() => {
    getBearer("get");
    axios
      .get(getApiLink("/api/analytics/projects/"))
      .then(({ data }) => {
        setProjectsList(data);
      });
    axios
      .get(getApiLink("/api/analytics/employees/"))
      .then(({ data }) => {
        setEmployeesList(data);
      });
  }, []);

  const selectDateMap = {
    min: [2024, 1],
    max: [new Date().getFullYear(), new Date().getMonth()+1]
  } as {
    min: [number, number]
    max: [number, number]
  }

  const isDisabled = (
    (projectStatisticValue.value === "project_statistic_report" && chosenProjects.length) 
    || 
    (projectStatisticValue.value === "employee_statistic_report" && chosenEmployees.length)
    || 
    (projectStatisticValue.value === "category_statistic_report" && chosenCategories.length && chosenProjectsForCategories.length && chosenEmployeesForCategories.length)
  );

  return (
    <section className="analytics">
      <div className="page-header">
        <div className="page-header__col">
            <h1 className="page-header__title title">
                <Translate>analytics_page.header.title</Translate>
            </h1>
        </div>
        <div className="page-header__col">
          <Notifications />
        </div>
        <div className={`page-header__row analytics-row${isLoadingCreatingReport ? " is-loading" : ""}${projectStatisticValue.value === "category_statistic_report" ? " mode-2" : ""}`}>
          <div className="page-header__select" style={{"--size": "235px", "--width": "235px"} as React.CSSProperties}>
              <CustomSelect list={projectStatisticList} setSelectedItem={setProjectStatisticValue} selectValue={projectStatisticValue}/>
          </div>

          {projectStatisticValue.value === "category_statistic_report" && 
          <CategoriesSelect chosenItems={chosenCategories} setChosenItems={setChosenCategories} />}

          {projectStatisticValue.value === "project_statistic_report" && 
          <ProjectsSelect chosenItems={chosenProjects} setChosenItems={setChosenProjects} list={projectsList} />}

          {projectStatisticValue.value === "category_statistic_report" && 
          <ProjectsSelect displayAll={true} chosenItems={chosenProjectsForCategories} setChosenItems={setChosenProjectsForCategories} list={projectsList} />}

          {projectStatisticValue.value === "employee_statistic_report" && 
          <EmployeesSelect chosenItems={chosenEmployees} setChosenItems={setChosenEmployees} list={employeesList} />}

          {projectStatisticValue.value === "category_statistic_report" && 
          <EmployeesSelect displayAll={true} chosenItems={chosenEmployeesForCategories} setChosenItems={setChosenEmployeesForCategories} list={employeesList} />}

          <div ref={rootEl} className={`section-table__add-task--time section-table__time drop-down is-right-default${isActiveSelectTime ? " is-active" : ""}`}>
            <button onClick={_ => setIsActiveSelectTime(prev => !prev)} className="section-table__time--target drop-down__target" type="button">
                <span>
                  <Translate>{MonthNumber()[fromMonth].translate_code}</Translate>, {fromYear}
                  {" - "}
                  {MonthNumber()[toMonth] && <Translate>{MonthNumber()[toMonth].translate_code}</Translate>}, {toYear}
                </span>
                <svg width="10" height="7" viewBox="0 0 10 7"
                      className="drop-down__target--arrow">
                    <use xlinkHref="#drop-down-arrow"></use>
                </svg>
            </button>
            <div className="section-table__time--block drop-down__block">
                <div className="section-table__time--item">
                    <div className="section-table__time--item-col">
                        <span><Translate>timesheet_page.popups.from</Translate>:</span>
                    </div>
                    <div className="section-table__time--item-col">
                      <SelectDate
                        month={fromMonth}
                        year={fromYear}
                        chosenYear={fromChosenYear}
                        minMax={selectDateMap}
                        onChangeMonth={(month: number) => {
                          
                          setFromMonth(month);
                          setFromYear(fromChosenYear);

                          if(fromChosenYear >= toYear) {
                            if(month > toMonth) {
                              setToMonth(month);
                            }

                            if(fromChosenYear === selectDateMap.max[0] && toMonth >= selectDateMap.max[1]) {
                              setToMonth(selectDateMap.max[1]);
                            }

                            setToYear(fromChosenYear);
                            setToChosenYear(fromChosenYear);
                            
                          }
                        }}
                        onChangeYear={(value: number) => {
                          setFromChosenYear(value);
                        }}
                        onInit={(list) => {
                          setSelectDateList((prev) => [...prev, list])
                        }} />
                    </div>
                </div>
                <div className="section-table__time--item">
                    <div className="section-table__time--item-col">
                        <span><Translate>timesheet_page.popups.to</Translate>:</span>
                    </div>
                    <div className="section-table__time--item-col">
                      <SelectDate
                        month={toMonth}
                        year={toYear}
                        chosenYear={toChosenYear}
                        minMax={selectDateMap}
                        onChangeMonth={(month: number) => {
                          setToMonth(month); 
                          setToYear(toChosenYear);

                          if(fromYear >= toChosenYear) {
                            setFromYear(toChosenYear);
                            setFromChosenYear(toChosenYear);
                            if(fromMonth > month) {
                              setFromMonth(month);
                            }
                          }
                        }}
                        onChangeYear={(value: number) => {
                          setToChosenYear(value);
                        }}
                        onInit={(list) => {
                          setSelectDateList((prev) => [...prev, list])
                        }} />
                    </div>
                </div>
                <div className="section-table__time--footer">
                  <button className="btn is-transparent" onClick={handleEntirePeriod}>
                    {t("analytics_page.statistic_report.select_entire_period")}
                  </button>
                </div>
            </div>
          </div>

          <button className="page-header__submit btn" type="button" {...(isDisabled ? null : {disabled: true})} onClick={handleCreateReport}>
            {t("analytics_page.statistic_report.submit")}
          </button>
          {analitycsData.length && projectStatisticValue.value !== "category_statistic_report" ? (
            <div className="page-header__full">
                <button onClick={_ => {
                  setPopup({popup: "export-generating-popup", data: t("analytics_export.loading_get_data")});

                  createReport(true, (analitycsData) => {
                    setPopup({popup: "export-generating-popup", data: t("analytics_export.generating_file")});

                    let period_list: string[] = [], period_items: {name: string, value: string}[] = [];
                    const end_year = new Date().getFullYear();
  
                    analitycsData.forEach(item => {
                      period_list.push(`${t(`${MonthNumber()[item.start_month].translate_code}`)}, ${item.start_year} - ${t(`${MonthNumber()[item.end_month].translate_code}`)}, ${item.end_year || end_year}`);
                    })
  
                    if(projectStatisticValue.value === "project_statistic_report") {
                      const employees: Record<string, string[]> = {},
                      projects: string[] = [];
  
                      chosenProjects.forEach(project => {
                        projects.push(project.name);
                      })
  
                      let timeDetails: ITimeDetail[] = [],
                          costDetails: ICostDetail[] = [];
  
                      analitycsData.forEach(item => {
                        timeDetails = timeDetails.concat(item.time_details);
                        costDetails = costDetails.concat(item.cost_details);
  
                        timeDetails = timeDetails.filter((item, index) => timeDetails.indexOf(item) === index);
                        costDetails = costDetails.filter((item, index) => costDetails.indexOf(item) === index);
                      })
  
                      timeDetails.forEach(time => {
                        if(projects.includes(time.project_name)) {
                          if(!employees[time.user_name]) {
                            employees[time.user_name] = [time.date];
                          } else if(!employees[time.user_name].includes(time.date)) {
                            employees[time.user_name].push(time.date);
                          }
                        }
                      })
  
                      costDetails.forEach(cost => {
                        if(projects.includes(cost.project_name)) {
                          if(!employees[cost.user_name]) {
                            employees[cost.user_name] = [cost.date];
                          } else if(!employees[cost.user_name].includes(cost.date)) {
                            employees[cost.user_name].push(cost.date);
                          }
                        }
                      })

                      for (const key in employees) {
                        employees[key] = employees[key].sort((a, b) => new Date(b).getTime() - new Date(a).getTime());
                      }
    
                      const getDateParams = (date: string): {month: number, year: number} => {
                        const dateParams = date.split("-");
    
                        return {
                          month: +dateParams[1],
                          year: +dateParams[0]
                        }
                      }
    
                      const getDate = (startDate: string, endDate: string): {start_month: number, start_year: number, end_month: number, end_year: number} => {
                        const startDateParams = getDateParams(startDate),
                        endDateParams = getDateParams(endDate);
    
                        return {
                          start_month: startDateParams.month,
                          start_year: startDateParams.year,
                          end_month: endDateParams.month,
                          end_year: endDateParams.year
                        }
                      }
                      
                      for (const key in employees) {
                        const date = getDate(employees[key][employees[key].length - 1], employees[key][0]);
                        
                        period_items.push({
                          name: key,
                          value: `${t(`${MonthNumber()[date.start_month].translate_code}`)}, ${date.start_year} - ${t(`${MonthNumber()[date.end_month].translate_code}`)}, ${date.end_year || end_year}`
                        });
                      }
  
                    } else {
                      analitycsData.forEach(item => {
                        period_items.push({
                          name: item.name,
                          value: `${t(`${MonthNumber()[item.start_month].translate_code}`)}, ${item.start_year} - ${t(`${MonthNumber()[item.end_month].translate_code}`)}, ${item.end_year || end_year}`
                        });
                      })
                    }
                    
                    handleDownloadFullAnalyticsData({
                      type: projectStatisticValue.value === "project_statistic_report" ? "projects" : "employees",
                      list: analitycsData,
                      period_list,
                      period_items
                    }, setPopup).catch(() => {
                      alert(t("errors.500"));
                      setPopup({popup: "", data: ""});
                    });

                  })

                }} className="section-table__export--target drop-down__target" type="button">
                    <Translate>summary_page.main.export_all</Translate>
                    <svg width="16" height="17" viewBox="0 0 16 17">
                        <use xlinkHref="#download"></use>
                    </svg>
                </button>
            </div>
          ) : <></>}
        </div>
      </div>
      <div className={`page-inner analytics-inner${isLoadedCreatingReport ? " is-loaded" : ""}`}>
          <div className={`analytics-none${(isLoadingCreatingReport) ? " is-loading" : ""}`}>
            <div className="analytics-none__inner">
              <div className="analytics-none__icon">
                <svg width="24" height="24">
                  <use href="#analytics"></use>
                </svg>
              </div>
              <div className="analytics-none__text">
                <p>
                  {t("analytics_page.none")}
                </p>
              </div>
            </div>
            <div className="analytics-none__loader">
              <div className="analytics-none__loader-element" aria-hidden={true}>
                <div></div>
              </div>
              <div className="analytics-none__loader-text">Calculating...</div>
            </div>
          </div>
        <AnimatePresence mode="wait">
          {isLoadedCreatingReport && <motion.div
            initial={{opacity: 0}}
            animate={{opacity: 1}}
            exit={{opacity: 0}}
            transition={{duration: .4}}
            className="analytics-list"
          >
            {analitycsData.map((analitycsData: IAnalyticsData) => {
              return resultType && <AnalyticsItem is={resultType} key={`analytics-item-${analitycsData.name}`} data={analitycsData} onExport={(timeChart, costChart) => {
                setPopup({popup: "export-generating-popup", data: t("analytics_export.loading_get_data")});
                createReport(true, (dataList) => {
                  setPopup({popup: "export-generating-popup", data: t("analytics_export.generating_file")});
                  const data: IAnalyticsData = dataList.filter(item => item.name === analitycsData.name)[0];
                  handleDownloadAnalyticsData({
                    name: data.name,
                    type: resultType || "projects",
                    emplo_name: data.name,
                    report_period: `${t(`${MonthNumber()[data.start_month].translate_code}`)}, ${data.start_year} - ${t(`${MonthNumber()[data.end_month].translate_code}`)}, ${data.end_year}`,
                    costImage: costChart,
                    hoursImage: timeChart,
                    timeDetails: data.time_details,
                    costDetails: data.cost_details,
                    cost: data.cost_statistics ? data.cost_statistics.map((item, index) => {
                      return {
                        id: index+1,
                        name: item.name,
                        color: item.color,
                        value: item.value
                      }
                    }) : null,
                    hours: data.time_statistics ? data.time_statistics.map((item, index) => {
                      return {
                        id: index+1,
                        name: item.name,
                        color: item.color,
                        value: item.value
                      }
                    }) : null
                  }, setPopup).catch(() => {
                    alert(t("errors.500"));
                    setPopup({popup: "", data: ""});
                  })
                }, {
                  projects: resultType === "projects" ? chosenProjects.filter(item => item.name === analitycsData.name.split("_")[0]) : undefined,
                  employer: resultType === "employees" ? chosenEmployees.filter(item => `${item.first_name} ${item.last_name}` === analitycsData.name) : undefined
                })
              }} />
            })}
            {(resultType === "categories" && categoriesAnalitycsData.categories.length) ? <AnalyticsCategoriesItem data={categoriesAnalitycsData} /> : null}
          </motion.div>}
        </AnimatePresence>
      </div>
    </section>
  );
};
